import { Map } from 'mapbox-gl'
import { when } from 'mobx'
import { Instance, SnapshotIn, types } from 'mobx-state-tree'

import { FGeoPointFragment } from '../../graph/generated'
import { gpsToLatLng } from '../../helpers/gps'
import { latLng } from './mapUtils'

const GPSCzechia = {
  latitude: 49.8037633,
  longitude: 15.4749126,
}

export const MapModel = types
  .model('Map')
  .props({
    zoom: types.optional(types.number, 18),
    latitude: types.optional(types.number, GPSCzechia.latitude),
    longitude: types.optional(types.number, GPSCzechia.longitude),
  })
  .volatile(() => ({
    initialized: false,
    mapLoaded: false,
    map: null as Maybe<Map>,
  }))
  .views(self => ({
    get isReady() {
      return self.map !== null && self.mapLoaded
    },
    get center() {
      return latLng(self.latitude, self.longitude)
    },
  }))
  .actions(self => ({
    setInitialized() {
      self.initialized = true
    },
    setMapLoaded() {
      self.mapLoaded = true
    },
    setMap(map: Map) {
      self.map = map
    },
    updateZoom() {
      if (self.map) {
        self.zoom = self.map.getZoom()
      }
    },
    updatePosition() {
      if (self.map) {
        const center = self.map.getCenter()
        self.latitude = center.lat
        self.longitude = center.lng
      }
    },
    panTo(gps: FGeoPointFragment) {
      const panNow = () => {
        const targetPosition = gpsToLatLng(gps)
        self.map!.panTo(targetPosition, { animate: true })
      }

      if (self.map) {
        panNow()
      } else {
        self.latitude = gps.latitude
        self.longitude = gps.longitude
        when(() => self.isReady, panNow)
      }
    },
  }))

export interface TMapModel extends Instance<typeof MapModel> {}
export interface TMapModelProps extends SnapshotIn<typeof MapModel> {}
